import i18next from 'i18next'
import { languages } from '../types/constants'
import common_de from './translations/de.json'
import common_en from './translations/en.json'
import common_fr from './translations/fr.json'
import common_it from './translations/it.json'

const browserLang = navigator.language.slice(0, 2).toLowerCase()
const lng = languages.includes(browserLang) ? browserLang : 'de'

i18next.init({
  interpolation: { escapeValue: false },
  lng,
  resources: {
    en: {
      common: common_en,
    },
    de: {
      common: common_de,
    },
    fr: {
      common: common_fr,
    },
    it: {
      common: common_it,
    },
  },
})
export default i18next
